import React from 'react'
import { useTranslation } from 'react-i18next'

const Login: React.FC = () => {
    const { t } = useTranslation()

    return <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">{t('Login')}</div>
}

export default Login
